import { HttpClient, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import * as moment from 'moment';
import { catchError } from 'rxjs';
import { errorHandl } from 'src/app/utils/network-utils';
import { urls } from 'src/app/utils/url.utils';
import { exportToExcel } from 'src/app/utils/utils.common';

@Injectable({
  providedIn: 'root'
})
export class StatisticsService {

  constructor(private http: HttpClient) { }
  get(queryParams?: any) {
    const params = new HttpParams({ fromObject: queryParams });
    return this.http.get(urls.API_URL + urls.STATISTICS, { params })
      .pipe(catchError(errorHandl));
  }
  getPrivatePayReport(queryParams?: any) {
    const params = new HttpParams({ fromObject: queryParams });
    return this.http.get(urls.API_URL + urls.BUSINESS_REPORT, { params })
      .pipe(catchError(errorHandl));
  }


  multiSheet(kpiData: any, companies: any, dateRange: any, tab: any, source: any = '') {
    const showPayment = source !== 'original';
    if (kpiData && companies && dateRange) {
      const formattedStart = moment(dateRange.startDate).format("MM_DD_YYYY");
      const formattedEnd = moment(dateRange.endDate).format("MM_DD_YYYY");
      const fileName = `statistics_${formattedStart}_To_${formattedEnd}.xlsx`;
      const table1 = [
        ['Date Range', moment(dateRange.startDate).format("MM/DD/YYYY") + ' - ' + moment(dateRange.endDate).format("MM/DD/YYYY")],
        [
          'Total Trips',
          ...(showPayment ? ['Paid Trips', 'Unpaid Trips'] : []),
          'Cancelled Trips',
          'Arrived Trips',
          'In Progress Trips',
          'Offered Trips',
          'Onway Trips',
          'Reroute Trips',
          'Scheduled Trips',
          'Completed Trips',
          'Pre Special Rate',
          'Special Rate',
          'Flat FS',
          'Flat Company',
          'Actual FS',
          'Actual Company',
          'Flat Commission',
          'Actual Commission',
          ...(showPayment ? ['Paid Amount', 'Unpaid Amount', 'Total Amount'] : []),

        ]
      ]
      table1.push([
        kpiData.total || 0,
        ...(showPayment ? [kpiData.totalPaid || 0, kpiData.totalUnpaid || 0] : []),
        kpiData.totalCancelled || 0,
        kpiData.totalArrived || 0,
        kpiData.totalInprogress || 0,
        kpiData.totalOffered || 0,
        kpiData.totalOnway || 0,
        kpiData.totalReroute || 0,
        kpiData.totalScheduled || 0,
        kpiData.totalCompleted || 0,

        kpiData.preSpecialTotal.toFixed(2) || 0,
        kpiData.specialTotal.toFixed(2) || 0,
        kpiData.flatFSTotal.toFixed(2) || 0,
        kpiData.flatCompanyTotal.toFixed(2) || 0,
        kpiData.actualFSTotal.toFixed(2) || 0,
        kpiData.actualCompanyTotal.toFixed(2) || 0,
        kpiData.flatCommissionTotal.toFixed(2) || 0,
        kpiData.actualCommissionTotal.toFixed(2) || 0,
        ...(showPayment
          ? [
            Number(kpiData.paidAmount || 0).toFixed(2),
            Number(kpiData.unpaidAmount || 0).toFixed(2),
            Number(kpiData.totalAmount || 0).toFixed(2),
          ]
          : []),
      ]);

      const table2 = [
        ['Date Range', moment(dateRange.startDate).format("MM/DD/YYYY") + ' - ' + moment(dateRange.endDate).format("MM/DD/YYYY")],
        [
          tab === 'company' ? 'Company' : 'Funding source',
          'Scheduled',
          'In Progress',
          'Canceled',
          'Onway',
          'Reroute',
          'Offered',
          'Arrived',
          'Completed',
          'Total Trips',
          ...(showPayment ? ['Paid Trips', 'Unpaid Trips'] : []),
          'Pre Special Rate',
          'Special Rate',
          'Flat FS',
          'Flat Company',
          'Actual FS',
          'Actual Company',
          'Flat Commission',
          'Actual Commission',
          ...(showPayment ? ['Paid Amount', 'Unpaid Amount', 'Total Amount'] : []),
        ]
      ]
      companies.forEach((item: any) => {
        table2.push([
          item.type === 'company' ? item.company?.name : item.fundingsource?.title || 'N/A',
          item.totalScheduled || 0,
          item.totalInprogress || 0,
          item.totalCancelled || 0,
          item.totalOnway || 0,
          item.totalReroute || 0,
          item.totalOffered || 0,
          item.totalArrived || 0,
          item.totalCompleted || 0,
          item.total || 0,
          ...(showPayment ? [item.totalPaid || 0, item.totalUnpaid || 0] : []),

          item.preSpecialTotal.toFixed(2) || 0,
          item.specialTotal.toFixed(2) || 0,
          item.flatFSTotal.toFixed(2) || 0,
          item.flatCompanyTotal.toFixed(2) || 0,
          item.actualFSTotal.toFixed(2) || 0,
          item.actualCompanyTotal.toFixed(2) || 0,
          item.flatCommissionTotal.toFixed(2) || 0,
          item.actualCommissionTotal.toFixed(2) || 0,
          ...(showPayment
            ? [
              Number(item.paidAmount || 0).toFixed(2),
              Number(item.unpaidAmount || 0).toFixed(2),
              Number(item.totalAmount || 0).toFixed(2),
            ]
            : []),
        ]);
      });
      const sheets = {
        "Dashboard": table1,
        "Records": table2,
      };
      exportToExcel(fileName, sheets);
    }
  }
}
